// Keeps main-area panels condensed and centered on wide screens
export const CONTENT_WIDTH = "mx-auto w-full max-w-[750px]";
